import { selectByMode } from "./mode";

/**
 * Écran de maintenance : bascule manuelle, le temps d'une migration ou d'un gros déploiement.
 * Passer l'environnement concerné à `true`, déployer, puis repasser à `false` une fois la bascule terminée.
 *
 * `test` reste toujours à `false` : les e2e tournent en `--mode test` et se retrouveraient sinon
 * toutes derrière l'écran de maintenance — à commencer par le préchauffage, qui ne peut plus se connecter.
 *
 * NB : la valeur est un objet, pas un booléen nu — `selectByMode` rejette les valeurs falsy (`if (!selected)`).
 */
const config = {
  localhost: { enabled: false },
  dev: { enabled: false },
  production: { enabled: false },
  test: { enabled: false },
  demo: { enabled: false },
};

export const MAINTENANCE = {
  ...selectByMode(config),
  returnTime: "12h30",
} as const;
